
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarGainIec as ObiRadarGainIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-gain-iec.js';
 
 
 

 
 export const ObiRadarGainIec = createComponent({
   react: React,
   tagName: 'obi-radar-gain-iec',
   elementClass: ObiRadarGainIecElement,
   events: {
     
   }
  });
 
 